<p-toast></p-toast>
<app-spinner></app-spinner>
<div class="card">
  <ng-container *ngIf="surveyQuestionData.length > 0; else no_question_found">
    <p-table
      #questionTable
      [columns]="dataColumn"
      [value]="surveyQuestionData"
      dataKey="id"
      *ngIf="surveyQuestionData"
      styleClass="p-datatable-responsive-demo"
      [paginator]="true"
      [rows]="5"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[5, 10, 50]"
      sortField="sequence"
      [sortOrder]="1"
      [globalFilterFields]="['qtext', 'qtype', 'sequence']"
    >
      <ng-template pTemplate="caption">
        <div class="p-d-flex">
          <span class="p-input-icon-left p-ml-auto">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="questionTable.filterGlobal($event.target.value, 'contains')"
              placeholder="Search keyword"
            />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th pSortableColumn="sequence">
            <p-sortIcon field="sequence"></p-sortIcon>
            Order of questions
          </th>
          <th pSortableColumn="qtext">
            <p-sortIcon field="qtext"></p-sortIcon>
            Question text
          </th>
          <th pSortableColumn="qtype">
            <p-sortIcon field="qtype"></p-sortIcon>
            Question type
          </th>
          <th *ngIf="!showAnswers">Unit</th>
          <th *ngIf="showAnswers">Annswer</th>
          <th>{{ showAnswers ? 'Detail' : 'Edit' }}</th>
          <th *ngIf="!showAnswers">Delete</th>
          <th>Clone</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td>{{ rowData.sequence }}</td>
          <td>{{ rowData.qtext }}</td>
          <td>{{ rowData.qtype }}</td>
          <td *ngIf="!showAnswers">{{ rowData.unit }}</td>
          <th *ngIf="showAnswers">
            <div *ngFor="let surveyAnswer of rowData['answer'] | keyvalue">
              <ng-container *ngIf="surveyAnswer.key !== 'qUUID'">
                <span *ngIf="surveyAnswer.key !== 'answer1'">
                  Key: <b>{{ surveyAnswer.key }}</b>
                </span>
                <span>
                  Value: <b>{{ surveyAnswer.value }}</b>
                </span>
              </ng-container>
            </div>
          </th>
          <td>
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-pencil"
              (click)="openEditForm(rowData)"
              class="p-button-rounded p-button-text"
            ></button>
          </td>
          <td *ngIf="!showAnswers">
            <button
              pButton
              pRipple
              type="button"
              icon="pi pi-trash"
              (click)="deleteQuestion(rowData)"
              class="p-button-rounded p-button-text"
            ></button>
          </td>
          <td>
            <button
              pButton
              pRipple
              (click)="cloneQuestion(rowData); $event.stopPropagation()"
              type="button"
              icon="pi pi-copy"
              class="p-button-rounded p-button-text"
            ></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
  <ng-template #no_question_found>
    <div class="noProductFound d-flex-col d-flex-centre">
      <span> No question found with the given survey. </span>
      <img src="../../../assets/images/core/not-found.png" />
    </div>
  </ng-template>
</div>
